/* eslint-disable prettier/prettier */
import  React from 'react';

export const paths = {
  LANDING_HOME_URL_PATH: '/',
  LANDING_PRICING_URL_PATH: '/pricing',
  LANDING_SUPPORT_URL_PATH: '/support',
  STORE_FINDER_URL_PATH: '/store-finder',
  FIND_STORE_URL_PATH: '/find-store',
  SWITCH_STORE_URL_PATH: '/switch-store',
  LOGIN_URL_PATH: '/login',
  FORGOT_PASSWORD_URL_PATH: '/forgot-password',
  RESET_PASSWORD_URL_PATH: '/reset-password',
  REGISTER_URL_PATH: '/join-us',
  DASHBOARD_URL_PATH: '/dashboard',
  PROFILE_URL_PATH: '/profile',
  POS_TELLER_URL_PATH: '/pos',
  CASH_REGISTER_TELLER_URL_PATH: '/action/cash-register',
  INVENTORIES_URL_PATH: '/inventories',
  PREFERENCES_URL_PATH: '/accounts/:tabId',
  CUSTOMERS_URL_PATH: '/accounts/customers',
  SUPPLIERS_URL_PATH: '/accounts/suppliers',
  USERS_URL_PATH: '/accounts/users',
  ADD_MISC_URL_PATH: '/new/:miscId',
  EDIT_MISC_URL_PATH: '/edit/:miscId',
  VIEW_MISC_URL_PATH: '/view/:miscId',
  DOES_NOT_EXIST_URL_PATH: '/does-not-exist',
  VERIFY_SUBSCRIPTION_CALLBACK_URL_PATH: '/verifying-subscription',
  UPGRADE_SUBSCRIPTION_URL_PATH: '/upgrade-subscription',
  STORE_INVENTORY_REPORT_URL_PATH: '/reports/store-inventory',
  SALE_RECEIPTS_REPORT_URL_PATH: '/reports/sale-receipts',
  DETAILED_SALES_REPORT_URL_PATH: '/reports/sales-detail',
  SUMMARY_SALES_REPORT_URL_PATH: '/reports/sales-summary',
};

const routes = [
  {
    path: paths.LANDING_HOME_URL_PATH,
    private: false,
    component: React.lazy(() => import('./pages/Landing/Home')),
  },
  {
    path: paths.LANDING_PRICING_URL_PATH,
    private: false,
    component: React.lazy(() => import('./pages/Landing/Pricing')),
  },
  {
    path: paths.LOGIN_URL_PATH,
    private: false,
    component: React.lazy(() => import('./pages/Login/Login')),
  },
  {
    path: paths.FORGOT_PASSWORD_URL_PATH,
    private: false,
    component: React.lazy(() => import('./pages/Password/ForgotPassword/ForgotPassword')),
  },
  {
    path: paths.RESET_PASSWORD_URL_PATH,
    private: false,
    component: React.lazy(() => import('./pages/Password/ResetPassword/ResetPassword')),
  },
  {
    path: paths.REGISTER_URL_PATH,
    private: false,
    component: React.lazy(() => import('./pages/Onboarding/Register')),
  },
  {
    path: paths.FIND_STORE_URL_PATH,
    private: false,
    component: React.lazy(() => import('./pages/FindStore/FindStore')),
  },
  {
    path: paths.DASHBOARD_URL_PATH,
    component: React.lazy(() => import('./pages/Dashboard/Dashboard')),
    private: true,
  },
  {
    path: paths.PROFILE_URL_PATH,
    component: React.lazy(() => import('./pages/Profile/Profile')),
    private: true,
  },
  {
    path: paths.POS_TELLER_URL_PATH,
    component: React.lazy(() => import('./pages/POSTeller/POSTeller')),
    private: true,
  },
  {
    path: paths.INVENTORIES_URL_PATH,
    component: React.lazy(() => import('./pages/Inventory/Inventory')),
    private: true,
  },
  {
    path: paths.CUSTOMERS_URL_PATH,
    component: React.lazy(() => import('./pages/Customers/Customers')),
    private: true,
    roles: ['Admin', 'Webmaster', 'Manager'],
  },
  {
    path: paths.SUPPLIERS_URL_PATH,
    component: React.lazy(() => import('./pages/Suppliers/Suppliers')),
    private: true,
    roles: ['Admin', 'Webmaster', 'Manager'],
  },
  {
    path: paths.USERS_URL_PATH,
    component: React.lazy(() => import('./pages/Users/Users')),
    private: true,
    roles: ['Admin', 'Webmaster', 'Manager'],
  },
  {
    path: paths.ADD_MISC_URL_PATH,
    component: React.lazy(() => import('./pages/Misc/Misc')),
    private: true,
    roles: ['Admin', 'Webmaster', 'Manager'],
  },
  {
    path: paths.EDIT_MISC_URL_PATH,
    component: React.lazy(() => import('./pages/Misc/Misc')),
    private: true,
    roles: ['Admin', 'Webmaster', 'Manager'],
  },
  {
    path: paths.VIEW_MISC_URL_PATH,
    component: React.lazy(() => import('./pages/Misc/Misc')),
    private: true,
  },
  {
    path: paths.CASH_REGISTER_TELLER_URL_PATH,
    component: React.lazy(() => import('./pages/CashRegister/CashRegister')),
    private: true,
  },
  {
    path: paths.VERIFY_SUBSCRIPTION_CALLBACK_URL_PATH,
    component: React.lazy(() => import('./pages/VerifySubscription/VerifySubscription')),
    private: true,
    roles: ['Admin', 'Webmaster', 'Manager'],
  },
  {
    path: paths.UPGRADE_SUBSCRIPTION_URL_PATH,
    component: React.lazy(() => import('./pages/UpgradeSubscription/UpgradeSubscription')),
    private: true,
    roles: ['Admin', 'Webmaster', 'Manager'],
  },
  {
    path: paths.PREFERENCES_URL_PATH,
    component: React.lazy(() => import('./pages/Preferences/Preferences')),
    private: true,
    roles: ['Admin', 'Webmaster'],
  },
  {
    path: paths.SWITCH_STORE_URL_PATH,
    component: React.lazy(() => import('./pages/SwitchStore/SwitchStore')),
    private: true,
    roles: ['Admin', 'Webmaster'],
  },
  {
    path: paths.STORE_INVENTORY_REPORT_URL_PATH,
    component: React.lazy(() => import('./pages/Reports/StoreInventory')),
    private: true,
    roles: ['Admin', 'Webmaster'],
  },
  {
    path: paths.SALE_RECEIPTS_REPORT_URL_PATH,
    component: React.lazy(() => import('./pages/Reports/Receipts')),
    private: true,
    roles: ['Admin', 'Webmaster'],
  },
  {
    path: paths.DETAILED_SALES_REPORT_URL_PATH,
    component: React.lazy(() => import('./pages/Reports/SalesDetail')),
    private: true,
    roles: ['Admin', 'Webmaster'],
  },
  {
    path: paths.SUMMARY_SALES_REPORT_URL_PATH,
    component: React.lazy(() => import('./pages/Reports/SalesSummary')),
    private: true,
    roles: ['Admin', 'Webmaster']
  },
];

export const attachedStoreRoutes = routes.filter(route => route.private).map(fndRoute => ({...fndRoute, path: `:store${fndRoute.path}`}))

export default routes;
